<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left">
          <a class="nav-item is-hidden-tablet" @click="$store.dispatch('TOGGLE_SIDEBAR')">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
        <div class="nav-center">
          <a class="nav-item hero-brand" href="./">
            <img src="~assets/ezlink.png" :alt="description">
            <div class="is-hidden-mobile">
              <strong class="ezlink">EZ Link</strong> <span class="customer">Customer Relations</span>
            </div>
          </a>
        </div>
        <div class="nav-right is-flex" style="padding-right: 40px;">
          <template v-if="$store.state.config.logged && $store.state.config.user">
            <div class="nav-item">
              <a @click="openNotifications()">
                <i class="fa fa-bell" aria-hidden="true" style="margin-top: 5px;"></i>
                <span class="tag is-warning">{{ $store.state.config.hasOwnProperty('notifications') ? $store.state.config.notifications.length : 0 }}</span>
              </a>
            </div>
            <div class="nav-item">{{ $store.state.config.user.name }}</div>
            <div class="nav-item">
              <tooltip label="Logout" type="default" placement="left">
                <a class="logout" @click="logout()">
                  <i class="fa fa-sign-out"></i>
                </a>
              </tooltip>
            </div>
          </template>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import auth from '../../auth'
  import Notifications from '../notifications/notifications'
  import Notification from 'vue-bulma-notification'
  import Tooltip from 'vue-bulma-tooltip'
  const NotificationComponent = Vue.extend(Notification)
  const showNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }
  export default {
    components: {
      Notifications,
      Tooltip
    },
    props: {
      show: Boolean
    },
    data () {
      return this.$store.state.pkg
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$store.state.config.logged) {
          // this.$options.sockets['alert-user-' + this.$store.state.config.user.id] = (data) => {
          //   let dataTemp = data
          //   this.showNotificationCustom(dataTemp.notification.replace(/<b>/g, ' ').replace(/<\/b>/g, ' '), 'info')
          //   this.$store.dispatch('ADD_NOTIFICATION', data)
          // }
        }
      })
    },
    methods: {
      logout () {
        auth.logout(this, true)
      },
      showNotificationCustom (message, type) {
        showNotification({
          title: '',
          message: message,
          type: type,
          duration: 15000
        })
      },
      openNotifications () {
        let propsData = {
          context: this,
          disabled: false
        }
        Notifications.openNotifications(propsData)
      }
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';

  .app-navbar {
    position: fixed;
    min-width: 100%;
    z-index: 1024;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

    .container {
      margin: auto 10px;
    }

    .nav-right {
      align-items: stretch;
      align-items: stretch;
      flex: 1;
      justify-content: flex-end;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
    }

    .logout {
      font-size: 19px;
      color: #A71C20;
      padding-top: 3px;
    }

  }

  .hero-brand {

  .ezlink {
    margin-left: 10px;
    color: #A71C20;
  }

  .customer {
    color: #F4A337;
  }

  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?4f448758